import { SelectedDateFilterType } from '@fnModels/matter-list';
import { MatterFileType, MatterStatus } from '@models/matter';

export class GetFilteredMatters {
	static readonly type = '[matter overview] Gettings filtered matter';
}

export class StoreConnected {
	static readonly type = '[matter overview] store connected';
}

export class SetFileTypeFilter {
	static readonly type = '[matter overview] setting file type filter';
	constructor(public fileType: MatterFileType) {}
}

export class SetStatusFilter {
	static readonly type = '[matter overview] setting status filter';
	constructor(public status: MatterStatus) {}
}

export class SetLawyerFilter {
	static readonly type = '[matter overview] setting lawyer filter';
	constructor(public lawyerId: string) {}
}

export class SetClerkFilter {
	static readonly type = '[matter overview] setting clerk filter';
	constructor(public clerkId: string) {}
}

export class SetDateFilter {
	static readonly type = '[matter overview] setting date filter';
	constructor(
		public from: string,
		public to: string,
	) {}
}

export class SetOfficeFilter {
	static readonly type = '[matter overview] setting office filter';
	constructor(public businessAddressId: string) {}
}

export class SetSelectedDateFilter {
	static readonly type = '[matter overview] setting selected date filter';
	constructor(public selectedDateFilter: SelectedDateFilterType) {}
}

export class SetOutstandingUndertaking {
	static readonly type = '[matter overview] setting outstanding undertaking';
	constructor(public outstandingUndertaking: boolean) {}
}

export class SetOutstandingRequisition {
	static readonly type = '[matter overview] setting outstanding requisition';
	constructor(public outstandingRequisition: boolean) {}
}

export class ResetFilter {
	static readonly type = '[matter overview] resetting filter';
}

export class DownloadCSV {
	static readonly type = '[matter overview] download CSV';
}
